<section class="fx-row w-full fx-center py-2">
  <div
    *ngFor="let option of options"
    [class]="getClasses(option.id, option.activeClass)"
    (click)="clickNode(option.id)">
    <ion-icon [src]="isSelected(option.id) ? option.iconActive : option.iconInactive"></ion-icon>
  </div>
</section>